import BigNumber from 'bignumber.js'
import { SerializedFarm, DeserializedPool, SerializedPool } from 'state/types'
import { deserializeToken } from 'state/user/hooks/helpers'
import { BIG_ZERO } from 'utils/bigNumber'

type UserData =
  | DeserializedPool['userData']
  | {
      allowance: number | string
      stakingTokenBalance: number | string
      stakedBalance: number | string
      pendingReward: number | string
    }

export const transformUserData = (userData: UserData) => {
  return {
    allowance: userData ? new BigNumber(userData.allowance) : BIG_ZERO,
    stakingTokenBalance: userData ? new BigNumber(userData.stakingTokenBalance) : BIG_ZERO,
    stakedBalance: userData ? new BigNumber(userData.stakedBalance) : BIG_ZERO,
    pendingReward: userData ? new BigNumber(userData.pendingReward) : BIG_ZERO,
  }
}

/**
 * Optionally pass in a known override for totalStaked (used for sousId 999 vault).
 */
export const transformPool = (
  pool: SerializedPool,
  overrideTotalStaked?: BigNumber
): DeserializedPool => {
  const { totalStaked, stakingLimit, userData, stakingToken, earningToken, ...rest } = pool

  const fixedTotalStaked =
    typeof overrideTotalStaked !== 'undefined'
      ? BigNumber.maximum(overrideTotalStaked, BIG_ZERO)
      : BigNumber.maximum(new BigNumber(totalStaked ?? '0'), BIG_ZERO)

  return {
    ...rest,
    performanceFee: (pool as any).performanceFee ?? 0,
    stakingToken: deserializeToken(stakingToken),
    earningToken: deserializeToken(earningToken),
    userData: transformUserData(userData),
    totalStaked: fixedTotalStaked,
    stakingLimit: new BigNumber(stakingLimit ?? '0'),
  }
}

export const getTokenPricesFromFarm = (farms: SerializedFarm[]) => {
  return farms.reduce((prices, farm) => {
    const quoteTokenAddress = farm.quoteToken.address.toLowerCase()
    const tokenAddress = farm.token.address.toLowerCase()

    if (!prices[quoteTokenAddress]) {
      prices[quoteTokenAddress] = new BigNumber(farm.quoteTokenPriceBusd).toNumber()
    }
    if (!prices[tokenAddress]) {
      prices[tokenAddress] = new BigNumber(farm.tokenPriceBusd).toNumber()
    }

    return prices
  }, {} as Record<string, number>)
}
